const SHOP_ITEMS_PER_CATEGORY = 2;
const BLEED_DAMAGE_PER_STACK = 1;
const REGEN_HEAL_PER_STACK = 4;
export {
  BLEED_DAMAGE_PER_STACK,
  REGEN_HEAL_PER_STACK,
  SHOP_ITEMS_PER_CATEGORY
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vbGliL2NvbnN0YW50cy50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiLy8gU2hvcCBjb25maWd1cmF0aW9uXG5leHBvcnQgY29uc3QgU0hPUF9JVEVNU19QRVJfQ0FURUdPUlkgPSAyO1xuXG4vLyBDb25kaXRpb24gdGljay1lZmZlY3QgYmFsYW5jZVxuZXhwb3J0IGNvbnN0IEJMRUVEX0RBTUFHRV9QRVJfU1RBQ0sgPSAxOyAvLyBub24tcmVkdWNpYmxlIEhQIGxvc3MgcGVyIHN0YWNrIHBlciB0aWNrXG5leHBvcnQgY29uc3QgUkVHRU5fSEVBTF9QRVJfU1RBQ0sgPSA0OyAvLyBIUCByZXN0b3JlZCBwZXIgc3RhY2sgcGVyIHRpY2tcbiJdLAogICJtYXBwaW5ncyI6ICJBQUNPLE1BQU0sMEJBQTBCO0FBR2hDLE1BQU0seUJBQXlCO0FBQy9CLE1BQU0sdUJBQXVCOyIsCiAgIm5hbWVzIjogW10KfQo=
